
import { Box, Button } from '@material-ui/core'
import { bosscatHomeServicesLogo, icons, idVerified } from 'assets/index'
import { userActions } from 'ducks/actions'
import { useAppDispatch } from 'ducks/hooks'
import { getUser, getUserPrimaryEmail } from 'ducks/selectors'
import { history } from 'helpers'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
type Props = {}

const RegisterSuccess = (props: Props) => {


    const push = history.usePush()
    const userEmail = useSelector(getUserPrimaryEmail)
    const user = useSelector(getUser)
    const auth0UserAppId = user?.auth0Id || ''
    const dispatch = useAppDispatch()

    const handleGoToLogin = () => {
        push('login')
    }

    const handleToSendAgain = () => {
        dispatch(userActions.sendSetPasswordEmail({ userEmail: userEmail, auth0Id: auth0UserAppId }, (success) => {
            if (success) {
                toast.success('Email sent successfully')
            } else {
                toast.error('Failed to send email')
            }
        }))
    }

    return (
        <Box width={"100%"} display="flex" flexDirection="column" alignItems={"center"} gridGap="16px" paddingTop={"40px"}>
            <img src={bosscatHomeServicesLogo} style={{ width: "280px", height: "66px", marginBottom: "96px" }} alt="bosscatHomeServicesLogo" />
            <img src={idVerified} alt="idVerified" />
            <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0", color: "#000" }}>ACTIVATE YOUR ACCOUNT</p>
            <p style={{ fontSize: "16px", fontWeight: "normal", margin: "0", color: "#000" }}>As a last step, we need you to activate your account.</p>
            <p style={{ fontSize: "16px", fontWeight: "normal", margin: "0", maxWidth: "450px", textAlign: "center", color: "#000" }}>We have sent you an email with the instructions to activate your account to your email: {userEmail}.</p>
            <Button onClick={handleGoToLogin} style={{ backgroundColor: "#2e7bf7", color: "white" }} variant="outlined" startIcon={<icons.Email style={{ color: "white", textTransform: "none" }} />}>{'Go to Login'}</Button>
            <Button onClick={handleToSendAgain} style={{ backgroundColor: "white", color: "#2e7bf7" }} variant="outlined" startIcon={<icons.Email style={{ color: "#2e7bf7", textTransform: "none" }} />}>{'Did not receive the email? Send again'}</Button>
        </Box>
    )
}

export default RegisterSuccess
